import { Form, Select } from "antd";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import BusinessSerializeSelector from "@/components/BusinessSerializeSelector";
import { useSelector } from "react-redux";
import { multipleAvail } from "@/constant/globalConstant";

export const CustomSelectorTab = ({ gridData, show, form, dashboard }) => {
  const { dashboardFilter = {} } = useSelector((state) => state.dashboardV2);

  const [isMulti, setIsMulti] = useState(true);

  useEffect(() => {
    if (!Array.isArray(gridData)) {
      setIsMulti(true);
      return;
    }
    const selectedComponent = gridData.filter((dt) => dashboardFilter?.selectedTiles?.includes(dt._id));
    const isSingle = selectedComponent.filter((dt) => !multipleAvail?.includes(dt.component));
    setIsMulti(!isSingle?.length);
  }, [dashboardFilter?.selectedTiles, gridData]);

  const tileListOptions =
    (Array.isArray(gridData)
      ? gridData
          ?.filter(({ component }) => !["textBox", "comboBar"].includes(component))
          ?.map(({ chartTitle, _id }) => {
            const plainTextTitle = chartTitle
              ?.replace(/<[^>]*>?/gm, "")
              ?.replace(/&nbsp;/g, " ")
              ?.replace(/&amp;/g, "&")
              ?.trim();

            return { label: plainTextTitle, value: _id, searchValue: plainTextTitle };
          })
      : []) || [];

  return (
    <div key={show}>
      <Form.Item label="Tile List" name="selectedTiles" className="w-100">
        <Select
          showSearch={{
            filterOption: (input, option) => (option?.searchValue ?? "").toLowerCase().includes(input.toLowerCase()),
          }}
          mode={"multiple"}
          maxTagCount={4}
          maxTagTextLength={20}
          placeholder="Select Tile"
          options={tileListOptions}
        />
      </Form.Item>

      <BusinessSerializeSelector
        {...{
          form,
          names: ["locations"],
          business: { params: { _id: dashboard?.business }, altName: "businesses" },
          parameter: { isMulti: isMulti },
        }}
      />
    </div>
  );
};

CustomSelectorTab.propTypes = {
  gridData: PropTypes.array,
  show: PropTypes.bool,
  form: PropTypes.object,
  dashboard: PropTypes.object,
};
